export const HOSTED_FILE_ROOT = "https://dobzyvcw0u1c8.cloudfront.net"